/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CeaInfindCeasByCta from './CeaInfindCeasByCta';
import CpaInfindCeasByCta from './CpaInfindCeasByCta';

/**
 * The ItemOfFindCeasByCtaResponse model module.
 * @module model/ItemOfFindCeasByCtaResponse
 * @version 2.8.0
 */
class ItemOfFindCeasByCtaResponse {
    /**
     * Constructs a new <code>ItemOfFindCeasByCtaResponse</code>.
     * @alias module:model/ItemOfFindCeasByCtaResponse
     * @param cpa {module:model/CpaInfindCeasByCta} 
     * @param foundCeas {Array.<module:model/CeaInfindCeasByCta>} 
     */
    constructor(cpa, foundCeas) { 
        
        ItemOfFindCeasByCtaResponse.initialize(this, cpa, foundCeas);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, cpa, foundCeas) { 
        obj['cpa'] = cpa;
        obj['foundCeas'] = foundCeas;
    }

    /**
     * Constructs a <code>ItemOfFindCeasByCtaResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ItemOfFindCeasByCtaResponse} obj Optional instance to populate.
     * @return {module:model/ItemOfFindCeasByCtaResponse} The populated <code>ItemOfFindCeasByCtaResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ItemOfFindCeasByCtaResponse();

            if (data.hasOwnProperty('cpa')) {
                obj['cpa'] = CpaInfindCeasByCta.constructFromObject(data['cpa']);
            }
            if (data.hasOwnProperty('tailCea')) {
                obj['tailCea'] = CeaInfindCeasByCta.constructFromObject(data['tailCea']);
            }
            if (data.hasOwnProperty('headCea')) {
                obj['headCea'] = CeaInfindCeasByCta.constructFromObject(data['headCea']);
            }
            if (data.hasOwnProperty('foundCeas')) {
                obj['foundCeas'] = ApiClient.convertToType(data['foundCeas'], [CeaInfindCeasByCta]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/CpaInfindCeasByCta} cpa
 */
ItemOfFindCeasByCtaResponse.prototype['cpa'] = undefined;

/**
 * @member {module:model/CeaInfindCeasByCta} tailCea
 */
ItemOfFindCeasByCtaResponse.prototype['tailCea'] = undefined;

/**
 * @member {module:model/CeaInfindCeasByCta} headCea
 */
ItemOfFindCeasByCtaResponse.prototype['headCea'] = undefined;

/**
 * @member {Array.<module:model/CeaInfindCeasByCta>} foundCeas
 */
ItemOfFindCeasByCtaResponse.prototype['foundCeas'] = undefined;






export default ItemOfFindCeasByCtaResponse;

